import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=7b9a06da&scoped=true&"
import script from "./Opportunity.vue?vue&type=script&setup=true&lang=js&"
export * from "./Opportunity.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a06da",
  null
  
)

export default component.exports